import { createContext } from "react"
/**
 * Global AppContext
 *
 * Used for notification (without redux)
 */
export const AppContext = createContext()
